import React from "react";
import Scaffold from "../../widget/layouts/Scaffold";
import AppTranslation from "../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../widget/layouts/ScreenMedia";
import ProductsContent from "./ProductsContent";
import ProductsActions from "./widget/ProductsAction";

const ProductsScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <Scaffold
      appBarTitle={AppTranslation.text("products")}
      appBarAction={<ProductsActions />}
    >
      <MainBodyContainer className="h-100">
        <ProductsContent type={type} isModal={false} />
      </MainBodyContainer>
    </Scaffold>
  );
};

export default ProductsScreen;
export const routeName: string = "/products";
